import React from 'react';
import styles from "../../styles.module.scss";
import SearchInput from '../../../../../../views/pages/manage/masters/onlinePackage/SearchInput';
import { searchStudents } from '../../../searchStudent/constants';
import { useWizard } from '../../../../../../components/wizard/WizardContext';
import AButton from '../../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { useNavigateToGivenPath } from '../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/service';
import { DataCell } from '../StudentDetails';
import { failureToast } from '../../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function';

const StudentDetailsCorrectionForm = ({
    form,
    setForm,
    setLoading
}) => {

    const navigateToGivenPath = useNavigateToGivenPath();

    const { dropdowns } = useWizard();

    const onCancel = () => setForm({});

    const searchApplicationId = async (val) => {
        try {
            if (!val) return;

            setLoading(true);
            const resp = await searchStudents({ applicationId: val }, 0, dropdowns?.data);
            if (resp?.code === 200) {
                const respDto = resp?.data?.studentApplicationDetailsSearchResponseDTOList || [];

                if (respDto?.length === 0) failureToast("Application Id not found!!");

                const studentDetails = respDto?.[0] ?? {};
                setForm(studentDetails);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={`${styles['student-details-correction-form']}`}>
            <div className={`${styles['title']}`}>Correct Student Details</div>

            <div className={styles['student-details']}>

                <div>
                    <div className={styles['label']}>Application ID</div>
                    <SearchInput
                        placeholder="Search Application ID"
                        inputStyles={{ minWidth: '100%', width: '100%', border: '1px solid #CFD3D4' }}
                        onCancel={onCancel}
                        searchInputValueHandler={searchApplicationId}
                        initialInputVal={form?.applicationId}
                    />
                </div>

                <DataCell label="PSID" value={form?.psid} />
                <DataCell label="Student Name" value={form?.studentName} />
                <DataCell label="BU" value={form?.businessAreaDispVal} />
                <DataCell label="Course ID" value={form?.courseId} />
                <DataCell label="Term" value={form?.termDispVal} />

            </div>

            {form?.psid &&
                <AButton
                    variant='link'
                    className='no-ml-btn mt-2'
                    onClick={() => navigateToGivenPath(`admin/edp/studentDetails/${form?.psid}`)}
                >
                    Student Dashboard →
                </AButton>
            }

        </div>
    );
}

export default StudentDetailsCorrectionForm;